import type { CollectionQueryState, CollectionQueryAdapter } from '@common/adapters/collection-query';
import type { EduCoursePaymentEntity } from '@common/types/payment-form.type';

import { createReducer, on } from '@ngrx/store';
import { createCollectionQueryAdapter } from '@common/adapters/collection-query';

import EduCoursePaymentsActions from './edu-course-payments.actions';

export const EDU_COURSE_PAYMENTS_COLLECTION_FEATURE_KEY = 'eduCoursePayments';

export type EduCoursePaymentsCollectionState = CollectionQueryState<EduCoursePaymentEntity[]>;

export const eduCoursePaymentsAdapter: CollectionQueryAdapter<EduCoursePaymentEntity[]> =
    createCollectionQueryAdapter<EduCoursePaymentEntity[]>();

export const eduCoursePaymentsCollectionReducer = createReducer<EduCoursePaymentsCollectionState>(
    eduCoursePaymentsAdapter.getInitialState(),
    on(EduCoursePaymentsActions.loadCollectionRequest, (state: EduCoursePaymentsCollectionState, { courseId }) =>
        eduCoursePaymentsAdapter.loadCollectionQueryRequest(state, courseId)
    ),
    on(
        EduCoursePaymentsActions.loadCollectionSuccess,
        (state: EduCoursePaymentsCollectionState, { courseId, eduCoursePayments }) =>
            eduCoursePaymentsAdapter.loadCollectionQuerySuccess(eduCoursePayments, courseId, state)
    ),
    on(EduCoursePaymentsActions.loadCollectionFailure, (state: EduCoursePaymentsCollectionState, { courseId, error }) =>
        eduCoursePaymentsAdapter.loadCollectionQueryFailure(error, courseId, state)
    )
);
